import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { getCreditHistory } from '../api/creditHistory/getCreditHistory';
import { getCreditHistoryPriority } from '@/components/content/creditHistoryPage/creditHistory.util';

export const useGetCreditHistory = () => {
  const { pathname } = useLocation();
  const pathSegment = pathname.split('/').filter(Boolean).pop();
  const priority = getCreditHistoryPriority(pathSegment);

  const { isLoading, data, isError } = useQuery({
    queryKey: ['credit-history', priority],
    queryFn: () => getCreditHistory(priority),
  });

  return {
    initializing: isLoading,
    creditHistory: data,
    isCreditHistoryError: isError,
  };
};
